import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { addOns } from '../../../mocks/servicesData';

export default function AddOns() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ rootMargin: '0px 0px -50px 0px' });

  return (
    <section className="py-28 bg-white relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div
          ref={headerRef}
          className={`text-center mb-16 scroll-animate ${headerVisible ? 'visible' : ''}`}
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-400"></div>
            <span className="text-amber-600 text-xs font-semibold tracking-[0.25em] uppercase">
              Enhance Your Event
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-400"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-display font-normal text-stone-900 mb-5">
            Popular Add-Ons
          </h2>
          <p className="text-stone-500 max-w-2xl mx-auto leading-relaxed">
            Complement any package with these premium extras. Mix and match to create your perfect event experience.
          </p>
        </div>

        <div
          ref={gridRef}
          className={`grid grid-cols-2 lg:grid-cols-4 gap-5 stagger-children ${gridVisible ? 'visible' : ''}`}
        >
          {addOns.map((item, idx) => (
            <div
              key={idx}
              className="group bg-stone-50 rounded-2xl p-6 border border-stone-100 hover:border-amber-200 hover:shadow-lg hover:bg-white transition-all duration-400 cursor-pointer text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-100 transition-colors">
                <i className={`${item.icon} text-xl text-amber-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-stone-900 mb-1">{item.name}</h3>
              <p className="text-xs text-stone-400 mb-3">{item.description}</p>
              <span className="text-amber-600 text-sm font-display font-semibold">{item.price}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
